import { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import Header from "@/components/header/Header";

import { DigitalAssetContext as SiteCredentialsDigitalAssetContext } from "@/contexts/site-credentials/DigitalAssetContext";
import { DigitalAssetContext as ContinenteCredentialsDigitalAssetContext } from "@/contexts/continente-credentials/DigitalAssetContext";
import { homeInformationService } from "@/services/site-credentials/mobile/HomeInformationService";
import { Config } from "@/config/Config";
import useScrollToHash from "@/components/UseScrollToHash";

type questionProps = {
  question: string;
  answer: string;
  anchor: string;
};

export default function Faq() {
  const siteCredentialsContext = useContext(SiteCredentialsDigitalAssetContext);
  const continenteCredentialsContext = useContext(ContinenteCredentialsDigitalAssetContext);

  const clientId = siteCredentialsContext.digitalAsset.clientId || continenteCredentialsContext.digitalAsset.clientId;

  const { hash, state } = useLocation<any>();
  const { t } = useTranslation();
  const { t: tFaqs } = useTranslation("faqs");

  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState<questionProps[]>([]);
  const [anchorSelected, setAnchorSelected] = useState<string | null>(null);

  const isDeepLink = state?.from === "dl";

  let PertoURL = "";

  switch (import.meta.env.VITE_NODE_ENV) {
    case "production":
      PertoURL =
        "https://modelocontinenteb2c.my.salesforce-sites.com/WebformCredenciais";
      break;
    case "development":
      PertoURL =
        "https://modelocontinenteb2c--preprod.sandbox.my.salesforce-sites.com/WebformCredenciais";
      break;
    default:
      PertoURL =
        "https://modelocontinenteb2c.my.salesforce-sites.com/WebformCredenciais";
  }

  PertoURL += "?tema1=Login+Continente&clientId=";

  const handlerGetUserInformation = async () => {
    //setLoading(true);

    let userInfo;

    try {
      const response = await homeInformationService.getHomeInfo(
        Config.SiteCredentials.homeInformationUrl
      );

      switch (response.kind) {
        case "success":
          userInfo = response.value;
          break;
        default:
          break;
      }

      //setLoading(false);
    } catch (e) {
      //setLoading(false);
    } finally {
      return userInfo;
    }
  };

  useScrollToHash(hash, setAnchorSelected);

  useEffect(() => {
    const faqs = tFaqs("faqs", {
      returnObjects: true,
    }) as questionProps[];

    if (typeof faqs === "object") {
      setQuestions(faqs);
    }

    setLoading(false);
  }, [hash, tFaqs]);

  function changeAnchorSelected(newAnchor: string | null) {
    if (newAnchor === anchorSelected) {
      newAnchor = null;
    }

    setAnchorSelected(newAnchor);
  }

  function loadUserSessionData() {
    const fetchData = async () => {
      const userInformation = await handlerGetUserInformation();

      if (userInformation) {
        const sfIframe = document.getElementById(
          "sfIframe"
        ) as HTMLIFrameElement;

        if (sfIframe.contentWindow != null) {
          sfIframe.contentWindow.postMessage(
            {
              nome: "",
              email: userInformation.usernameEmail,
              telemovel: userInformation.usernamePhoneNumber,
            },
            "*"
          );
        }
      }
    };

    fetchData().catch(console.error);
  }

  const customStyles = `
    a {
      color: var(--on-surface-primary-default-variant);
    }
    a:hover {
      text-decoration: underline
    } 
  `;

  return (
    <div className="flex flex-col gap-12 pb-2">
      <Header
        title={t("site_credentials.helpCenter")}
        showLoading={loading}
        previousStepBackXTimes={1}
        showBackButton={!isDeepLink}
      />
      {!loading && questions != null && questions.length > 0 && (
        <div className="faq-container mt-1">
          <Accordion type="single"
            collapsible
            defaultValue={anchorSelected ? anchorSelected : undefined}
            className="w-full">
            {questions.map((q, i) => (
              <AccordionItem key={q.anchor} id={q.anchor} value={q.anchor} variant={"container"}>
                <AccordionTrigger onClick={() => changeAnchorSelected(q.anchor)}>{q.question}</AccordionTrigger>
                <AccordionContent>
                  <style>{customStyles}</style>
                  <div dangerouslySetInnerHTML={{ __html: q.answer }}></div>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      )}
      <iframe
        id="sfIframe"
        className="w-full min-h-[1100px]"
        //onLoad={loadUserSessionData}
        src={PertoURL + clientId}
      ></iframe>
    </div>
  );
}
